import './styles.css'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getFaq } from '../../../../services/Financeiro/ReembolsoService';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import CardPergunta from './CardPergunta';
import { Pergunta } from '../../../../interfaces/entities/Reembolso/Pergunta';
import { Button, CircularProgress, Typography } from '@mui/material';
import { sxButtonText, sxButtonVoltar } from './sxProps';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import PageTitle from '../../../../components/Accessibility/PageTitle';


function ReembolsoFAQ() {

  const navigate = useNavigate();
  const accessibility = useAccessibility();

  const [data, setData] = useState<Pergunta[]>([]);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    getFaq()
      .then(response => {
        setData(response);
      })
      .catch(error => {
        console.log(error);
        setShowErrorModal(true);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [])

  return (
    <div className="reembolso-faq-container">
      <PageTitle text="Perguntas frequentes" />

      { !isLoading && 
        <div className="lista-perguntas-container">
        {
          data.map(p => {
            return <CardPergunta title={p.title} text={p.text} />
          })
        }
        </div>
      }

      {
        isLoading &&
        <div className="centered-div">
          <CircularProgress />
        </div>
        
      }
 
      <Button
        sx={sxButtonVoltar}
        onClick={() => navigate('/financeiro/reembolso')}
        startIcon={<FontAwesomeIcon icon={faChevronLeft} color="#383838"/>}
        aria-label="Voltar para menu Reembolso"
      >
        <Typography style={accessibility.textStyleAccessibility} sx={sxButtonText}>Voltar</Typography>
      </Button>
      <ModalFeedBack
        showModal={showErrorModal}
        handleShowModal={() => { setShowErrorModal(false); }}
        icon={'error'}
        textButton={''}
        title={'Atenção'}
        subTitle={'Erro ao buscar dados. Tente novamente mais tarde.'}
      />
    </div>
  )
}

export default ReembolsoFAQ